<template>
  <div>
    <main-nav />
    <Sidebar />
    <div class="app-wrapper">
      <router-view></router-view>
    </div>
    <div class="accept_terms" v-if="userDataExist">
      <base-model
        @close="model_1.show_model = false"
        :show="!userDataExist.is_accept_term"
      >
        <h4>{{ $t("labels.acceptTerms") }}</h4>
        <p class="desc_term" v-html="terms.desc" v-if="terms"></p>
        <v-checkbox
          v-model="model_1.accept"
          :label="$t('labels.acceptTerms')"
        ></v-checkbox>
        <div class="button_wrapper center">
          <v-btn
            type="submit"
            @click="acceptTerms"
            :disabled="btnLoading || !model_1.accept"
            :loading="btnLoading"
          >
            {{ $t("submit") }}
          </v-btn>
        </div>
      </base-model>
    </div>
  </div>
</template>

<script>
// START:: IMPORTING VUEX HELPERS
import { mapGetters } from "vuex";
// END:: IMPORTING VUEX HELPERS
import io from "socket.io-client";
import Sidebar from "@/components/Layouts/Sidebar.vue";

import MainNav from "../components/Layouts/MainNav.vue";

export default {
  name: "Home",

  components: { Sidebar, MainNav },

  data() {
    return {
      btnLoading: false,
      model_1: {
        show_model: false,
        accept: false,
      },
      activeUserData: {},
      userDataExist: null,
      terms: null,
      baseUrl: process.env.VUE_APP_BASE_URL_GENERAL,
    };
  },

  computed: {
    // START:: VUEX GET AUTHENTICATED USER DATA
    ...mapGetters("auth_module", ["currentUser"]),
    // END:: VUEX GET AUTHENTICATED USER DATA
    chats() {
      return this.$store.getters["chat_module/chats"];
    },
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },

  methods: {
    show_model_1() {
      this.model_1.show_model = true;
    },
    launch_resize_dispatch() {
      this.$store.dispatch("sideNav_module/onResize");
    },
    getUserData() {
      this.axios.get("profile").then((data) => {
        this.userDataExist = data.data.data;
      });
      this.axios
        .get(`${process.env.VUE_APP_BASE_URL_GENERAL}term`)
        .then((data) => {
          this.terms = data.data.data;
        });
    },
    acceptTerms() {
      this.btnLoading = true;
      this.axios({
        method: "post",
        url: "accept_term",
      })
        .then(() => {
          this.btnLoading = false;
          this.getUserData();
        })
        .catch((err) => {
          this.btnLoading = false;
          this.$iziToast.error({
            displayMode: 2,
            title: this.$t("error"),
            message: err.response.data.message ?? err.response.data.messages,
          });
        });
    },
    setMessage(payload) {
      var audio = document.createElement("AUDIO");
      document.body.appendChild(audio);
      let found = this.chats.find((el) => el.id == payload.data.id);
      if (found) {
        found.last_message = payload.data.message;
        found.last_message_created_at = payload.data.ago_time;
        found.last_message_created = new Date(
          payload.data.created_at
        ).getTime();
        found["is_read"] = payload.data.is_read;
      }

      if (payload.data.message_type == "complaint") {
        audio.src = require("@/assets/media/sounds/complaint.wav");
        audio.play();
        this.$swal({
          title: this.$t("newComplaint"),
          text: `${this.$t(payload.data.sender.user_type)}  ${this.$t(
            payload.data.sender.name
          )}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.$t("cancel"),
          confirmButtonText: this.$t("show"),
        }).then((result) => {
          if (result.isConfirmed) {
            this.$router.push("/chats");
          }
        });
      } else {
        audio.src = require("@/assets/media/sounds/notification.wav");
        audio.play();
        this.$iziToast.show({
          title: this.$t("newMessage"),
          message: `${this.$t(payload.data.sender.user_type)}  ${this.$t(
            payload.data.sender.name
          )}`,
          balloon: true,
          displayMode: 2,
          timeout: 15000,
        });
      }
    },
    allChatSoket() {
      const _self = this;
      var socket = io(process.env.VUE_APP_BASE_SOCKET_URL);

      socket.on(
        `AdminNotification:${localStorage.getItem(
          "myTeam_Academy_Dash_User_Id"
        )}`,
        (payload) => {
          console.log(payload);
          if (payload) {
            var audio = document.createElement("AUDIO");
            document.body.appendChild(audio);
            // var audio = new Audio();
            if (payload.notify_type == "unusual_behaviour") {
              audio.src = require("@/assets/media/sounds/complaint.wav");
              audio.play();
              this.$swal({
                title: payload.title[this.$i18n.locale],
                text: payload.body[this.$i18n.locale],
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: this.$t("cancel"),
                confirmButtonText: this.$t("show"),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router
                    .push(`/trips/show/${payload.trip_id}`)
                    .catch(() => {});
                }
              });
            } else {
              // var audio = new Audio();
              audio.src = require("@/assets/media/sounds/notification.wav");
              audio.play();
            }

            let dataToPush = {
              data_id: payload.data_id ?? payload.ticket_id,
              body: payload.body,
              title: payload.title,
            };

            _self.$store.commit(
              "notifications_module/pushNotification",
              dataToPush
            );

            // console.log(payload);
            this.$iziToast.show({
              title: payload.title[this.$i18n.locale],
              message: payload.body[[this.$i18n.locale]],
            });
          }
        }
      );
    },
    getPermissions() {
      this.axios
        .get("get_my_permissions")
        .then((res) =>
          localStorage.setItem(
            "myTeam_Academy_Dash_permissions",
            JSON.stringify(res.data.data)
          )
        );
    },
    getControls() {
      this.axios
        .get("get_my_control_permissions")
        .then((res) =>
          localStorage.setItem("myTeam_controls", JSON.stringify(res.data.data))
        );
    },
    async getActiveUserData() {
      this.activeUserData = await this.axios({
        method: "GET",
        url: `profile`,
        params: { internal: 1 },
      });
      // console.log(
      //   "currentUserData",
      //   this.activeUserData.data.data.is_notifications
      // );
    },
  },

  mounted() {
    // this.$store.dispatch("chat_module/getChats");
    // this.$store.dispatch("notifications_module/getNotifications");
    // this.allChatSoket();
    // console.log("Home Mounted", this.user.is_notifications);
    this.getUserData();
  },
  async created() {
    if (this.user.usertype != "academy") {
      await this.getActiveUserData();
      if (
        this.activeUserData.data.data.is_notifications !==
        localStorage.getItem("myTeam_Academy_Dash_User_Is_Notifications")
      ) {
        // console.log("Not equal");
        localStorage.setItem(
          "myTeam_Academy_Dash_User_Is_Notifications",
          this.activeUserData.data.data.is_notifications
        );
      }
      // this.getPermissions();
      // this.getControls();
    } else {
      if (localStorage.getItem("myTeam_controls")) {
        localStorage.removeItem("myTeam_controls");
      }
      if (localStorage.getItem("myTeam_Academy_Dash_permissions")) {
        localStorage.removeItem("myTeam_Academy_Dash_permissions");
      }
    }
  },
};
</script>

<style lang="scss">
.desc_term {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
